import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { config } from '@branding/config';
import { PostHogProvider } from 'posthog-js/react';
import posthog, { CapturedNetworkRequest } from 'posthog-js';

const container = document.getElementById('root');
const root = createRoot(container!);

if (typeof window !== 'undefined') {
	// Valid workaround for PostHog bug #2922: Store a reference to the native fetch
	// BEFORE PostHog initializes and monkeys-patches it.
	(window as any)._nativeFetch = window.fetch;

	posthog.init(config.posthogKey, {
		api_host: config.posthogHost,
		disable_session_recording: true,
		loaded: (posthog) => {
			if (!config.isDevelopment) posthog.startSessionRecording({});
		},
		session_recording: {
			maskCapturedNetworkRequestFn: (request: CapturedNetworkRequest) => {
				return request;
			},
		},
	});
}
root.render(
	<PostHogProvider client={posthog}>
		<App />
	</PostHogProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
